import { camelCase } from "lodash";
import { models, permission } from "utils/permissionCheck";

export const permissionCategories = Object.values(models).map(camelCase);

export const permissionActions = Object.entries(permission);